// extracted by mini-css-extract-plugin
module.exports = {"profilePhoto":"ProfilePhotoAdvisor-module__profilePhoto--KKc4g","advisorImage":"ProfilePhotoAdvisor-module__advisorImage--2fneW"};